import { useEffect, useState } from "react";
import { onValue, ref } from "firebase/database";
import { getPathDatabaseByRole } from "../actions/auth";
import { useDispatchApp } from "../lib/redux";
import { db } from "../lib/firebase";

const defaultFlags = {
  brandSetup: false,
  creatives: false,
  posts: false,
  campaigns: false,
  skipGuide: false,
};

export const useOnboardingChecklistData = () => {
  const dispatch = useDispatchApp();
  const [state, setState] = useState(() => ({
    ...defaultFlags,
    isReady: false,
  }));

  useEffect(() => {
    const { pathOnboardingChecklist } = dispatch(getPathDatabaseByRole());

    if (!pathOnboardingChecklist) {
      setState({ ...defaultFlags, isReady: true });
      return undefined;
    }

    const checklistRef = ref(db, pathOnboardingChecklist);
    const unsubscribe = onValue(checklistRef, (snapshot) => {
      const data = snapshot.val();
      if (!data) {
        setState({ ...defaultFlags, isReady: true });
        return;
      }

      const {
        campaigns = false,
        posts = false,
        creatives = false,
        brandSetup = false,
        skipGuide = false,
      } = data;

      setState({
        brandSetup: Boolean(brandSetup),
        creatives: Boolean(creatives),
        posts: Boolean(posts),
        campaigns: Boolean(campaigns),
        skipGuide: Boolean(skipGuide),
        isReady: true,
      });
    });

    return () => unsubscribe();
  }, [dispatch]);

  return {
    brandSetup: state.brandSetup,
    creatives: state.creatives,
    posts: state.posts,
    campaigns: state.campaigns,
    skipGuide: state.skipGuide,
    isReady: state.isReady,
  };
};
